module.exports = __webpack_public_path__ + "static/img/valueadd20.7a96679.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/valueadd20.png
// module id = chLW
// module chunks = 1